// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"d83ad269","319":"25e0911c","446":"1f56fad0","505":"e4179985","588":"e4179985","814":"d83ad269"}[chunkId] + ".css";
};